import { z } from 'zod';
import { mongoObjectIdString, optionalMongoObjectId } from './object-id-helpers.js';

const dateLike = z.string().or(z.date());

export const GapSchema = z.object({
    id: z.string().optional(),
    control: mongoObjectIdString,
    name: z.string().trim().min(1),
    description: z.string().optional(),
    currentState: z.string().optional(),
    desiredState: z.string().optional(),
    gapDescription: z.string().optional(),
    severity: z.enum(['critical', 'high', 'medium', 'low']).optional(),
    impact: z.string().optional(),
    remediationPlan: z.string().optional(),
    estimatedEffort: z.string().optional(),
    estimatedCost: z.number().optional(),
    identifiedDate: dateLike.optional(),
    targetClosureDate: dateLike.optional(),
    actualClosureDate: dateLike.optional(),
    assignee: optionalMongoObjectId,
    status: z.enum(['open', 'in-progress', 'pending-verification', 'closed', 'accepted']).optional(),
    soaApplicability: z.enum(['applicable', 'not-applicable', 'partial']).optional(),
    soaJustification: z.string().optional(),
    soaImplementationStatus: z
        .enum(['not-implemented', 'partially-implemented', 'implemented', 'not-applicable'])
        .optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: dateLike.optional(),
    updatedAt: dateLike.optional(),
});

export const CreateGapSchema = GapSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateGapSchema = GapSchema.partial();
